"use strict";

exports.__esModule = true;
exports.default = capitalize;

/**
 * Ajoute une lettre majuscule à la première lettre de la chaîne.
 */
function capitalize(str) {
  return str.slice(0, 1).toUpperCase() + str.slice(1);
}